// ✅ Countries data with prioritized order
export const Countries = [
  // 🥇 Prioritized countries at the top
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    flag: "/images/flag/Kuwait.png",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    flag: "/images/flag/Saudi.png",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    flag: "/images/flag/Pakistan.png",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    flag: "/images/flag/Bahrain.png",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    flag: "/images/flag/Qatar.png",
  },
  {
    name: "UAE",
    dial_code: "+971",
    code: "AE",
    flag: "/images/flag/Uae.png",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    flag: "/images/flag/Oman.png",
  },
];

// ✅ Regex map per country (using country dial codes as keys)
export const phonePatterns = {
  '965': /^[569]\d{7}$/,        // Kuwait: starts with 5, 6, or 9, followed by 7 digits
  '966': /^5\d{8}$/,            // Saudi Arabia: starts with 5, followed by 8 digits
  '92': /^3\d{9}$/,             // Pakistan: starts with 3, followed by 9 digits
  '973': /^3\d{7}$/,            // Bahrain: starts with 3, followed by 7 digits
  '974': /^[3567]\d{7}$/,       // Qatar: starts with 3, 5, 6, or 7, followed by 7 digits
  '971': /^(50|52|54|55|56|58)\d{7}$/, // UAE: starts with 50, 52, 54, 55, 56, or 58, followed by 7 digits
  '968': /^[79]\d{7}$/,         // Oman: starts with 7 or 9, followed by 7 digits
};

// ✅ Map country codes to dial codes for pattern lookup
export const countryCodeToDialCode = {
  'KW': '965',
  'SA': '966',
  'PK': '92',
  'BH': '973',
  'QA': '974',
  'AE': '971',
  'OM': '968',
};

// ✅ Get max digits based on country
export const getMaxDigits = (countryCode) => {
  const dialCode = countryCodeToDialCode[countryCode] || '965';
  switch (dialCode) {
    case "92":  // Pakistan
      return 10; // 3 + 9 digits
    case "965": // Kuwait
      return 8;  // [569] + 7 digits
    case "966": // Saudi Arabia
      return 9;  // 5 + 8 digits
    case "973": // Bahrain
      return 8;  // 3 + 7 digits
    case "974": // Qatar
      return 8;  // [3567] + 7 digits
    case "971": // UAE
      return 9;  // (50|52|54|55|56|58) + 7 digits
    case "968": // Oman
      return 8;  // [79] + 7 digits
    default:
      return 10;
  }
};

// ✅ Validate phone number for specific country
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber || phoneNumber.length === 0) {
    return { isValid: true, error: "" }; // Empty is valid (not required yet)
  }

  // Get dial code from country code
  const dialCode = countryCodeToDialCode[countryCode] || '965';
  const regex = phonePatterns[dialCode];
  
  if (!regex) {
    return { isValid: true, error: "" }; // No validation for unknown countries
  }

  // Remove any spaces, dashes, or other formatting
  const cleanPhone = phoneNumber.replace(/[\s\-\(\)]/g, '');

  if (!regex.test(cleanPhone)) {
    const country = Countries.find(c => c.code === countryCode);
    return { 
      isValid: false, 
      error: `Invalid ${country?.name || countryCode} phone number format`
    };
  }

  return { isValid: true, error: "" };
};

// ✅ Get mask pattern based on country
export const getMaskPattern = (countryCode) => {
  const dialCode = countryCodeToDialCode[countryCode] || '965';
  switch (dialCode) {
    case "92":  // Pakistan: 3 + 10 digits = 10 total
      return "9999999999";
    case "965": // Kuwait: [569] + 8 digits = 8 total
      return "99999999";
    case "966": // Saudi Arabia: 5 + 8 digits = 9 total
      return "999999999";
    case "973": // Bahrain: 3 + 8 digits = 8 total
      return "99999999";
    case "974": // Qatar: [3567] + 8 digits = 8 total
      return "99999999";
    case "971": // UAE: (50|52|54|55|56|58) + 8 digits = 9 total
      return "999999999";
    case "968": // Oman: [79] + 8 digits = 8 total
      return "99999999";
    default:
      return "9999999999"; // 10 digits default
  }
};
